const findAndStoreUtmTags = () => {
  if (typeof window === 'undefined') return; // Ensure we are in the browser

  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gclid',
    'gad_source',
  ];

  const utmData: { [key: string]: string } = {};

  utmParams.forEach((param) => {
    const value = urlParams.get(param);
    if (value) {
      utmData[param] = value;
      try {
        localStorage.setItem(param, value); // Store each param separately
      } catch (error) {
        console.error(`Could not store ${param} in localStorage`, error);
      }
    }
  });

  // Optionally store the entire UTM data object as a JSON string
  if (Object.keys(utmData).length > 0) {
    try {
      localStorage.setItem('utmData', JSON.stringify(utmData));
    } catch (error) {
      console.error('Could not store utmData in localStorage', error);
    }
  }
};

export default findAndStoreUtmTags;
